function updateLabel(selectElement) {
  const emptyOption = selectElement.querySelector('option[value=""]');
  const labelElement = selectElement.nextElementSibling;
  if (selectElement.value === "") {
    labelElement.classList.add('no-selection');
    if (emptyOption) {
      emptyOption.disabled = false;
    }
  } else {
    labelElement.classList.remove('no-selection');
    if (emptyOption) {
      emptyOption.disabled = true;
    }
  }
}

function initializeDateInputs(): void {
  console.log('init-date-inputs');
  document.querySelectorAll('input[type="date"]').forEach((input: HTMLInputElement) => {
    const defaultValue = input.defaultValue;
    if (defaultValue) {
      const parsedDate: Date = new Date(defaultValue);
      if (!isNaN(parsedDate.getTime())) {
        input.value = parsedDate.toISOString().split('T')[0];  // Extract YYYY-MM-DD part
      }
    }
  });
}

function initializeSelectElements() {
  document.querySelectorAll('.float-label-group select.form-select').forEach(selectElement => {
    updateLabel(selectElement);
    selectElement.addEventListener('change', function () {
      updateLabel(selectElement);
    });
  });
}

function applyValidationErrorClassesToMissedFields() {
  const getRelevantSibling = (element: HTMLElement | null): HTMLElement | null => {
    while (element) {
      element = element.previousElementSibling as HTMLElement;
      if (element && element.tagName !== "LABEL") {
        return element;
      }
    }
    return null;
  };

  const updateValidationStyles = () => {
    const errorSpans = document.querySelectorAll<HTMLSpanElement>(".field-validation-error");

    errorSpans.forEach((errorSpan) => {
      const relevantSibling = getRelevantSibling(errorSpan.previousElementSibling as HTMLElement);
      if (relevantSibling && ["SELECT", "TEXTAREA"].includes(relevantSibling.tagName)) {
        relevantSibling.classList.add("input-validation-error");
        console.log(`Class added to:`, relevantSibling);
      }
    });
  };

  updateValidationStyles();

  document.querySelectorAll("form").forEach((form) => {
    form.addEventListener("submit", () => {
      updateValidationStyles();
      console.log("Validation updated on form submit");
    });
  });
}

// manually remove error validation from persisting between like reporting form fields
document.getElementById('SelectedReport')?.addEventListener('change', () => {
  document.querySelectorAll('input.input-validation-error, select.input-validation-error, textarea.input-validation-error')
    .forEach(x => x.classList.remove('input-validation-error'));
  document.querySelectorAll('span.field-validation-error')
    .forEach(x => {
      x.classList.remove('field-validation-error');
      x.classList.add('field-validation-valid');
      x.textContent = '';
    });
});

function recaptchaFix() {
  var recaptchaContainer = document.querySelector(".g-recaptcha");
  var validationMessage = document.querySelector("[data-valmsg-for='FormData.Recaptcha']");

  function updateRecaptcha() {
    if (recaptchaContainer) {
      // Move value of container name attribute to hidden textarea
      var recaptchaName = recaptchaContainer.getAttribute('name');
      if (recaptchaName) {
        var textarea = recaptchaContainer.querySelector('textarea#g-recaptcha-response');
        if (textarea) {
          textarea.setAttribute('name', recaptchaName);
          recaptchaContainer.removeAttribute('name');
        } else {
          // Retry later if textarea is not yet available
          setTimeout(updateRecaptcha, 100);
          return;
        }
      }

      // Update the validation error state on the container
      if (validationMessage && validationMessage.innerHTML.trim() !== "") {
        recaptchaContainer.classList.add("input-validation-error");
      } else {
        recaptchaContainer.classList.remove("input-validation-error");
      }
    }
  }

  // Delay execution to ensure reCAPTCHA is fully loaded
  setTimeout(updateRecaptcha, 1000);
}

// Function to clear all inputs of the button's parent form
function clearFormInputs() {
  const clearForm = document.querySelector(".clear-form");
  if (clearForm) {
    clearForm.addEventListener("click", function (e) {
      e.preventDefault();

      const form = this.closest("form"); // Find the closest form tag
      if (form) {
        const elements = form.querySelectorAll("input, textarea, select");

        // use caution if adding hidden field clearing
        elements.forEach(element => {
          if (element.type === "text" || element.type === "password" || element.tagName === "TEXTAREA" || element.type === "date" || element.type === "email" || element.type === "tel" || element.type === "url") {
            element.value = "";
          } else if (element.type === "checkbox" || element.type === "radio") {
            element.checked = false;
          } else if (element.tagName === "SELECT") {
            element.selectedIndex = -1;
          }
        });
      }
    });
  }
}

// Function to check all checkboxes in the containing div
function checkAllCheckboxes() {
  const checkAll = document.querySelector(".check-all");
  if (checkAll instanceof HTMLInputElement && checkAll.type === "checkbox") {
    checkAll.addEventListener("change", function () {
      const container = checkAll.closest("div.checkboxes");
      if (container) {
        // Cast NodeList to an array of HTMLInputElement
        const checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]:not(.check-all)')) as HTMLInputElement[];
        checkboxes.forEach(checkbox => checkbox.checked = checkAll.checked);
      }
    });
  }
}

// member list submission
function memberListSubmit() {
  const tableBody = document.getElementById("member-table-body");
  if (!tableBody) return;

  tableBody.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;

    // Ensure it's an input element with the `data-memberId` attribute
    if (target.matches("[data-memberId]")) {
      event.preventDefault();

      const memberId = target.getAttribute("data-memberId");
      const hiddenField = document.getElementById("FormData_MemberId") as HTMLInputElement;
      const form = hiddenField?.closest("form");

      if (hiddenField && memberId) {
        hiddenField.value = memberId;
        form?.submit();
      }
    }
  });
}

// webclaim/reimbursement - save for later
function saveForLater() {
  document.querySelectorAll("[data-wf-save]").forEach(button => {
    button.addEventListener("click", (event) => {
      const btn = event.currentTarget as HTMLElement;
      const form = btn.closest("form"); // Find the closest form
      const hiddenField = btn.nextElementSibling as HTMLInputElement;
      hiddenField.value = "True";

      if (form) {
        form.submit(); // Submit the form
      }
    });
  });
};

function generatedIdCardRedirect() {
  const hiddenField = document.getElementById("generated-id-card-redirect") as HTMLInputElement;
  if (hiddenField && hiddenField.value) {
    window.open(hiddenField.value, '_blank');
  }
};

// blank placeholders are required for labels moving above fields
function enforceBlankPlaceholdersForUmbracoForms() {
  document.querySelectorAll(".umbraco-forms-form .umbraco-forms-page .form-control")
    .forEach((el) => {
      if (!el.hasAttribute("placeholder")) {
        el.setAttribute("placeholder", " ");
      }
    });
}

document.addEventListener("DOMContentLoaded", enforceBlankPlaceholdersForUmbracoForms);
document.addEventListener("DOMContentLoaded", generatedIdCardRedirect);
document.addEventListener("DOMContentLoaded", saveForLater);
document.addEventListener("DOMContentLoaded", memberListSubmit);
document.addEventListener("DOMContentLoaded", checkAllCheckboxes);
document.addEventListener("DOMContentLoaded", clearFormInputs);
document.addEventListener("DOMContentLoaded", recaptchaFix);
document.addEventListener('DOMContentLoaded', initializeDateInputs);
document.addEventListener('DOMContentLoaded', initializeSelectElements);
document.addEventListener("DOMContentLoaded", applyValidationErrorClassesToMissedFields);
